import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { TextareaProps } from "./PropsType";

export default function Textarea(props: TextareaProps) {
  const [data, setData] = useState({
    value: props.defaultValue || "",
    length: props.maxLength,
    focus: false,
  });

  const handleChange = (event: any) => {
    const value: any = event.target.value;
    const { onChange }: any = props;
    setData({
      ...data,
      value,
    });
    if (onChange) {
      onChange({
        value,
        originalEvent: event,
      });
    }
  };

  const handleFocus = (event: any) => {
    setData({
      ...data,
      focus: true,
    });
    if (props.onFocus) {
      props.onFocus({
        originalEvent: event,
      });
    }
  };

  const handleBlur = (event: any) => {
    setData({
      ...data,
      focus: false,
    });
    if (props.onBlur) {
      props.onBlur({
        originalEvent: event,
      });
    }
  };

  const {
    autoFocus,
    animated,
    className,
    disabled,
    id,
    inline,
    maxHeight,
    label,
    prefixCls = "bm-Textarea",
    placeholder,
    readOnly,
    rows,
    size = "sm",
  } = props;
  const { focus, length, value } = data;
  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-inner`]: inline,
      [`${prefixCls}-animated`]: animated,
      [`${prefixCls}-focus`]: focus!,
      [`${prefixCls}-noEmpty`]: value.trim() !== "",
    },
    `${prefixCls}-${size}`,
    className
  );
  const styles = {
    maxHeight,
  };

  useEffect(() => {
    setData({
      ...data,
      value: props.value || "",
    });
  }, [props.value]);

  return (
    <div className={styleClass} style={styles}>
      <label htmlFor={id}>
        {label ? <div className={`${prefixCls}-label`}>{label}</div> : null}
        <div className={`${prefixCls}-field`}>
          <textarea
            autoFocus={autoFocus}
            rows={rows}
            id={id}
            value={value!}
            placeholder={placeholder}
            disabled={disabled}
            readOnly={readOnly}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <span className={`${prefixCls}-indicator`}>{length}</span>
        </div>
      </label>
      <hr />
    </div>
  );
}

